import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "./LandingPage.css";
import Home from "../Home/Home";
import About from "../About/About";
import Features from "../Features/Features";
import Footer from "../Footer/Footer";
import Roadmap from "../Roadmap/Roadmap";
import Contact from "../Contact/Contact";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Landingpage = () => {
	const [activeSection, setActiveSection] = useState("home");
	const navigate = useNavigate();
	const isLoggedIn = () => {
		const token = localStorage.getItem("token");
		const role = localStorage.getItem("role");
		
		if (token && role) {
			if (role === "T") {
				navigate("/teacher/home");
			} else if (role === "S") {
				navigate("/student/home");
			}
		}
	};

	useEffect(() => {
		isLoggedIn();
	}, []);
	

	

	useEffect(() => {
		const handleScroll = () => {
			const sectionOffsets = {
				home: document.getElementById("home")?.offsetTop,
				about: document.getElementById("about")?.offsetTop,
				features: document.getElementById("features")?.offsetTop,
				roadmap: document.getElementById("roadmap")?.offsetTop,
				contact: document.getElementById("contact")?.offsetTop,
			};

			const scrollPosition = window.scrollY + 100;
			let newActiveSection = "home";

			for (const section in sectionOffsets) {
				if (
					sectionOffsets[section] &&
					scrollPosition >= sectionOffsets[section]
				) {
					newActiveSection = section;
				}
			}

			setActiveSection(newActiveSection);
		};

		const delayExecution = () => {
			if (
				document.getElementById("home") &&
				document.getElementById("about") &&
				document.getElementById("features") &&
				document.getElementById("roadmap") &&
				document.getElementById("contact")
			) {
				handleScroll();
			} else {
				setTimeout(delayExecution, 100);
			}
		};

		delayExecution();

		window.addEventListener("scroll", handleScroll);

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	return (
		<>
			<Navbar
				bg="light"
				data-bs-theme="light"
				className="bg-main justify-content-around"
				fixed="top"
				expand="lg">
				<Container>
					<Navbar.Brand href="#">LurW</Navbar.Brand>
					
					<Navbar.Toggle aria-controls="navbarScroll" />

					<Navbar.Collapse id="navbarScroll">
						<Nav className="navbar-nav">
							<Nav.Item>
								<Nav.Link href="#home" active={activeSection === "home"}>
									Home
								</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link href="#about" active={activeSection === "about"}>
									About
								</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link
									href="#features"
									active={activeSection === "features"}>
									Features
								</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link href="#roadmap" active={activeSection === "roadmap"}>
									Road Map
								</Nav.Link>
							</Nav.Item>
							<Nav.Item>
								<Nav.Link href="#contact" active={activeSection === "contact"}>
									Contact
								</Nav.Link>
							</Nav.Item>
						</Nav>
					</Navbar.Collapse>
					<Nav.Item className="login-btn">
						<Link to={'/login'}>Login / Signup</Link>
					</Nav.Item>
				</Container>
			</Navbar>
			<div className="main-content">
				<div id="home">
					<Home />
				</div>
				<div id="about">
					<About />
				</div>
				<div id="features">
					<Features />
				</div>
				<div id="roadmap">
					<Roadmap />
				</div>
				<div id="contact">
					<Contact />
				</div>
			</div>
			<Footer />
		</>
	);
};

export default Landingpage;
